/**
 * AUTO GENERATED :: DO NOT EDIT DIRECTLY
 */

export const Endpoints = {
  main_section: 'https://help.benchling.com/hc/en-us/sections/18965531484813-Benchling-In-Vivo',
  study_codes:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G8TPSEVVRKHG2NXGG6HQ6B',
  treatment_groups:
    'https://help.benchling.com/hc/en-us/articles/40008252686861-Create-and-update-an-In-Vivo-Study#h_01K6G8ZAFJN763KR989CF7TDQS',
  custom_study_forms:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G8GFRSCFYGTFJHBXAMC6RZ',
  registering_animals:
    'https://help.benchling.com/hc/en-us/articles/21952582878093-Registering-Animals-in-the-Vivarium',
  presets:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G834BPF44DWYD9RWXSM56R',
  study_alerts:
    'https://help.benchling.com/hc/en-us/articles/40008252686861-Create-and-update-an-In-Vivo-Study#h_01K6G9JPJRM3R8R4ZCC0TZ6GA4',
  linking_benchling_folder:
    'https://help.benchling.com/hc/en-us/articles/40004359355917-Use-the-In-Vivo-Sync-app#h_01K6G3N9ZAHFYFR64TCDC71FEW',
  randomizing_study_groups:
    'https://help.benchling.com/hc/en-us/articles/21952582878093-Manage-animals#h_01K6G5DJ7XGPBXR6PJSY3B7XCS',
  recaging: 'https://help.benchling.com/hc/en-us/articles/22269908325005',
  cage_cards:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G8TPS99ZX3MT194XDPPC0G',
  register_devices:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6GANEE40974MJ6M115D0CM6',
  device_connections:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6GANEE40974MJ6M115D0CM6',
  device_management:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6GANEE40974MJ6M115D0CM6',
  bulk_dosing:
    'https://help.benchling.com/hc/en-us/articles/40010334917133-Dosing-and-treatment-tools-for-In-Vivo#h_01K6GC63ED134AD0W0T34745HS',
  food_fluid_tracking:
    'https://help.benchling.com/hc/en-us/articles/40015207295373-How-to-configure-and-use-In-Vivo-Workflows',
  cage_food_fluid_calculations:
    'https://help.benchling.com/hc/en-us/articles/35892180041997-Cage-Food-and-Fluid-Intake-calculations',
  adding_tasks: 'https://help.benchling.com/hc/en-us/articles/22039063448077-Adding-and-amending-Tasks',
  task_management: 'https://help.benchling.com/hc/en-us/articles/20133802456077-Task-Management',
  formula_columns:
    'https://help.benchling.com/hc/en-us/articles/40011720965389-Configure-and-use-Data-Tables-in-In-Vivo#h_01K6GEAVTWJ5PNJWEQABKY32WB',
  timestamp_baseline_columns: 'https://help.benchling.com/hc/en-us/articles/22269843865357',
  datatable_workflows: 'https://help.benchling.com/hc/en-us/articles/22038901161613',
  metadata:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G7HNB5JRBKCSF18PHD09KJ',
  treatments:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G7Q3HF13V5N2P2KG3EA52R',
  creating_presets:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-a-Benchling-In-Vivo-tenant#h_01K6G834BPF44DWYD9RWXSM56R',
  benchling_backfill:
    'https://help.benchling.com/hc/en-us/articles/40004359355917-Use-the-In-Vivo-Sync-app#h_01K6G3PR1KE3QXHFV5FV1PGDJD',
  moving_animals_different_preset:
    'https://help.benchling.com/hc/en-us/articles/35892118046093-Moving-animals-to-a-study-with-a-different-preset',
  moving_animals_between_studies:
    'https://help.benchling.com/hc/en-us/articles/21952582878093-Manage-animals#h_01K6G6HSZTGN2CMYHVQ5AVFZYE',
  bulk_sample_collection:
    'https://help.benchling.com/hc/en-us/articles/40007893115661-Manage-animal-samples#h_01K6G8G3QQ4WCQGWGZEYGHP6CJ',
  single_sign_on:
    'https://help.benchling.com/hc/en-us/articles/40004872709261-Configure-your-Benchling-In-Vivo-tenant#h_01K6G91XR7EEPYPBTSA3WX1YTQ',
  import_data:
    'https://help.benchling.com/hc/en-us/articles/40014625319565-Collect-view-and-export-data-in-In-Vivo#h_01K6GJFJ6HD8NM1BH1QTQ46TJY',
  tracking_date:
    'https://help.benchling.com/hc/en-us/articles/21952582878093-Manage-animals#h_01K6G5DJ7DN9R5K9TKX2J4CPVB',
} as const;

export type EndpointKey = keyof typeof Endpoints;
